import { ChangeDetectorRef, Component, Inject, Input } from '@angular/core';
import { TransactionService, WalletService } from '@cai-services';
import { APP_PROPS } from '../../../../cai-common.module';
import { ApplicationProperties } from '../../../../core/_base/layout/models/app-properties.model';

@Component({
  selector: 'kt-topup-thankyou',
  templateUrl: './topup-thankyou.component.html',
  styleUrls: ['./topup-thankyou.component.scss'],
  standalone: false,
})
export class TopupThankyouComponent {
  @Input() walletName = '';
  @Input() transactionId = '';
  @Input() referenceId = '';
  @Input() shouldDownload: boolean;
  @Input() status: string;

  constructor(
    @Inject(APP_PROPS)
    private readonly appProperties: ApplicationProperties,
    private readonly transactionService: TransactionService,
    private readonly walletService: WalletService,
    private readonly cdr: ChangeDetectorRef,
  ) {}
  topupRequestTxt = $localize`:@@wallet.topup-topuprequest-label:TOP UP REQUEST`;
  invoiceTxt = $localize`:@@wallet.topup-invoice-label:INVOICE`;
  isLoading = false;
  downloadInvoice() {
    if (this.transactionId && !this.isLoading) {
      this.isLoading = true;
      setTimeout(() => {
        if (this.isCargoWallet) {
          this.transactionService
            .getAttachments(this.referenceId, 'CARGOAI_INVOICE')
            .then((res) => {
              window.open(res[0].attachment.url);
            });
        } else {
          this.walletService
            .downloadInvoiceOrRecipt(this.referenceId, 'invoice')
            .then((res) => {
              window.open(res?.link);
            });
        }
        this.isLoading = false;
        this.cdr.detectChanges();
      }, 5000);
    }
  }

  get walletBaseUrl(): string {
    return this.appProperties.walletBaseUrl + (this.isFailed ? '/top-up' : '');
  }
  get isCargoWallet(): boolean {
    return this.appProperties.name === 'cargowallet';
  }
  get lowerInvoiceTxt() {
    return this.isCargoWallet
      ? this.topupRequestTxt.toLowerCase()
      : this.invoiceTxt.toLowerCase();
  }
  get isFailed(): boolean {
    return this.status === 'failed';
  }
}
